import { render, staticRenderFns } from "./SectionClientProfile.vue?vue&type=template&id=1f78b83e&"
import script from "./SectionClientProfile.vue?vue&type=script&lang=js&"
export * from "./SectionClientProfile.vue?vue&type=script&lang=js&"
import style0 from "./SectionClientProfile.vue?vue&type=style&index=0&id=1f78b83e&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports